package com.example.mystybag.communication.internal

import kotlin.js.console

internal actual fun commLog(message: String) {
    // Log failures as console.error so they appear in Safari/Chrome "Errors" tab
    if (message.contains("FAILED", ignoreCase = true) || message.contains("failed", ignoreCase = true)) {
        console.error("[Communication]", message)
    }
    console.log(message)
}
